<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="title"
    width="800px"
    top="5vh"
    :close-on-click-modal="false"
    :destroy-on-close="true"
    class="main-content"
  >
    <div class="section" style="width: 100%">
      <div style="display: flex">
        <div style="text-align: left; display: flex; width: 100%">
          <el-input v-model="from.inputText" :placeholder="$t('CargoMsg.Cargo_inputMblTip')" style="width: 700px;padding-right: 5px;" class="input-border" no="inputText" @keyup.enter.native="handleEnterHandler" />
        </div>
        <div style="text-align: right; width: 30%">
          <el-button type="primary" style="height: 60px" @click="saveHandler">{{ $t('CargoMsg.Cargo_Save') }}</el-button>
        </div>
      </div>
      <div style="width: 100%;padding-top: 5px">
        <div>
          <el-form
            label-position="right"
            label-width="62px"
            style="width: 100%;"
          >
            <el-form-item :label="$t('SeaExport.MasterBillNo')">
              <span style="font-size: 18px"> {{ from.mblStr }} </span>
            </el-form-item>
            <div style="display: flex">
              <div style="width: 90%; display: flex">
                <el-form-item :label="$t('CargoMsg.Cargo_Terminal')">
                  <cargo-advance-select
                    no="cargoTerminalOperation"
                    :select-type="selectTypeNames.basic_data_AirportCargoTerminal"
                    :method-params="{dataType:0, deletionFlag: false}"
                    filterable
                    :clearable="true"
                    style="width: 150px"
                    :disabled="true"
                    :default-value="from.cargoTerminalOperation"
                    @parentCallBack="p=>{from.cargoTerminalOperation=p.value}"
                  />
                </el-form-item>
                <el-form-item :label="$t('CargoMsg.Cargo_CustomerName')">
                  <cargo-company-select
                    :method-params="{customer:true}"
                    :default-value="from.customerId"
                    no="customerId"
                    style="width: 150px"
                    :disabled="true"
                    @change="p=>{from.customerId=p.value}"
                  />
                </el-form-item>
              </div>
              <div style="text-align: right;width: 10%;">
                <el-upload
                  action
                  multiple
                  :auto-upload="false"
                  :show-file-list="false"
                  :on-change="toChooseFile"
                  no="1"
                >
                  <el-button type="success" style="height: 30px">{{ $t('CargoMsg.Cargo_FileUpload') }}</el-button>
                </el-upload>
              </div>
            </div>

          </el-form>
          <el-form
            label-position="right"
            label-width="62px"
            style="width: 100%;"
            :disabled="!isEditing"
          >
            <div style="display: flex">
              <el-form-item :label="$t('CargoMsg.Cargo_TotalPieces')">
                <auto-number-input
                  v-model="from.quantity"
                  no="quantity"
                  :enforce-min="true"
                  :precision="0"
                  style="width: 150px"
                  :min="0"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TotalGrossWeight')">
                <auto-number-input
                  v-model="from.weight"
                  no="weight"
                  :precision="3"
                  style="width: 150px"
                  :min="0"
                  @change="chargeWeightChange"
                />
              </el-form-item>
              <el-form-item :label="$t('CargoMsg.Cargo_TotalVolume')">
                <auto-number-input
                  v-model="from.volume"
                  no="volume"
                  :precision="3"
                  :min="0"
                  @change="chargeWeightChange"
                />
              </el-form-item>

              <el-form-item :label="$t('CargoMsg.Cargo_TotalChargeableWeight')">
                <auto-number-input
                  v-model="from.chargeWeight"
                  no="chargeWeight"
                  :enforce-min="true"
                  :precision="3"
                  :min="0"
                />
              </el-form-item>
            </div>
            <div>
              <el-form-item :label="$t('CargoMsg.Cargo_Size')">
                <div><a style="color:#1F75D5;font-size:16px;" @click="onDimensionFrom">{{ from.measurements }}✎</a></div>
              </el-form-item>
            </div>

            <div>
              <cargo-ag-grid
                ref="goodsTable"
                config-module="20250323"
                :grid-options="detailList.gridOptions"
                :column-defs="detailList.column"
                :row-data="from.dataList || []"
                @gridReady="params=>{detailList.gridApi=params.api}"
              />
            </div>
            <div style="padding-top: 10px">
              <span>{{ $t('CargoMsg.Cargo_FileInfo') }}</span>
              <cargo-ag-grid
                ref="goodsTable"
                config-module="20250324"
                :grid-options="fileList.gridOptions"
                :column-defs="fileList.column"
                :row-data="from.fileList || []"
                @gridReady="params=>{fileList.gridApi=params.api}"
              />
            </div>
          </el-form>
        </div>
      </div>
    </div>
    <div slot="footer" style="text-align: right">
      <el-button type="default" @click="onCancel">{{ $t('CargoMsg.Cargo_Close') }}</el-button>
    </div>

    <!-- 选择尺寸 -->
    <dimensions-dialog
      v-if="dimensionsDialog.visible"
      :visible.sync="dimensionsDialog.visible"
      :uuid="dimensionsDialog.uuid"
      :single-weight="dimensionsDialog.singleWeight"
      :dimension="dimensionsDialog.dimension"
      @sizeData="sizeDataHandler"
      @close="dimensionsDialog.visible = false"
    />
  </el-dialog>
</template>

<script>

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect.vue'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput.vue'
import URL from '@/api/urlTranslator'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect.vue'
import { AutoIncrementNum, DocumentManage } from '@/utils/commonUtil'
import { getUuid } from '@/utils'
import { getLoading } from '@/utils/utilBaseElement'
import { queryJobForMblFunc, saveDeliveryOperation } from '@/api/AirExport/airExportJob'
import { PriceUtils } from '@/class/cargo/model/utils/PriceUtils'
import * as NumberUtils from '@/utils/NumberUtils'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor/index.vue'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor/index.vue'
import DimensionsDialog from '@/components/Cargo/FrontEndWarehouse/components/warehouseHome/dimensionsDialog.vue'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { cache, cacheName } from '@/utils/cacheManager'
import { batchUploadFileForJob } from '@/api/seaExport/seaExportJob'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'

export default {
  name: 'DeliveryOperation',
  components: { DimensionsDialog, cargoCompanySelect, AutoNumberInput, cargoAdvanceSelect },
  props: {
    visible: {
      type: Boolean,
      default: () => false
    },
    title: {
      type: String,
      default: ''
    },
    pageType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      gridApi: null,
      selectTypeNames: TYPE_NAMES,
      autoIncrementNum: new AutoIncrementNum(),
      port: {},
      addKey: 'addDeliveryOperation_',
      documentManage: new DocumentManage(),
      dimensionsDialog: {
        dimension: '',
        uuid: '',
        singleWeight: 0,
        visible: false
      },
      from: {
        inputText: '',
        cargoTerminalOperation: '',
        customerId: '',
        jobNo: '',
        mbl: '',
        mblStr: '',
        uuid: '',
        quantity: 0,
        weight: 0,
        volume: 0,
        chargeWeight: 0,
        measurements: null,
        deliveryStatus: 0,
        outboundWeightDate: '',
        deliveryDate: '',
        dataList: [],
        fileList: [],
        deleteFileList: []
      },
      detailList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true,
          // 添加编辑组件
          frameworkComponents: {
            CargoAgGridCommonInputEditor,
            CargoAgGridCommonTextareaEditor
          }
        },
        column: [
          {
            headerName: this.$t('CargoMsg.Cargo_SeparateNumber'),
            field: 'hbl',
            colId: 'hbl',
            width: 100
          },
          {
            headerName: this.$t('CargoMsg.Cargo_CargoTerminalGrossWeight'),
            field: 'grossWeight',
            colId: 'grossWeight',
            width: 120,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 2,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 2)).format('0,0.00') || 0.000
            },
            onCellValueChanged: (params) => this.onCellChange(params)
          },
          {
            headerName: this.$t('CargoMsg.Cargo_ItemsNBR'),
            field: 'quantity',
            colId: 'quantity',
            width: 120,
            // 是否开启编辑
            editable: () => false
          },
          {
            headerName: this.$t('CargoMsg.Cargo_Cubage') + '(CBM)',
            field: 'volume',
            colId: 'volume',
            width: 150,
            // 是否开启编辑
            editable: () => this.isEditing,
            // 单元格绑定编辑组件
            cellEditor: 'CargoAgGridCommonInputEditor',
            // 编辑组件入参
            cellEditorParams: {
              isNumber: true,
              inputProps: {
                precision: 3,
                max: 999999999,
                min: 0,
                controlsPosition: 'right',
                style: 'width: 100%'
              }
            },
            valueFormatter: params => {
              return this.$numeral(NumberUtils.roundHalfUp(params.value, 3)).format('0,0.000') || 0.000
            },
            onCellValueChanged: (params) => {
              this.onCellChange(params)
            }
          },
          {
            headerName: this.$t('SeaExport.CargoSize'),
            field: 'measurements',
            colId: 'measurements',
            maxWidth: 500,
            minWidth: 300,
            editable: () => false,
            cellRenderer: params => {
              const onDimension = this.documentManage.getPath('onDimension')
              let value = params.value
              if (value && value.length > 30) {
                value = value.substring(0, 29) + '...'
              }
              return `<div><a onclick="${onDimension}('${params.data.uuid}')" style="color:#1F75D5;font-size:16px;">${value}✎</a></div>`
            }
          }
        ]
      },
      fileList: {
        gridApi: null,
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          singleClickEdit: true
        },
        column: [
          {
            headerName: this.$t('CargoMsg.Cargo_SequenceNumber'),
            colId: 'seq',
            field: 'seq',
            width: 115
          },
          {
            headerName: this.$t('SeaExport.FileName'),
            colId: 'fileName',
            field: 'fileName',
            width: 175,
            cellRenderer: params => {
              if (params.data.fileId) {
                return `<a href="${URL.common.findByFileId}/${
                  params.data.fileId
                }?sessionId=${
                  this.$store.getters.token
                }" target="_blank" style="color:blue">${params.value}</a>`
              } else {
                return params.value
              }
            }
          },
          {
            headerName: this.$t('CargoMsg.Cargo_FileFormat'),
            colId: 'fileType',
            field: 'fileType',
            width: 115
          },
          {
            headerName: this.$t('SeaExport.Operation'),
            colId: 'fileType',
            field: 'fileType',
            width: 115,
            cellRenderer: params => {
              const onDelC = this.documentManage.getPath('onDelC')
              if (params.value) {
                return `<div>
                        <a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.token}" target="_blank" style="color:blue">${this.$t('FileHistory.fileDownload')}</a>
                        <a onclick="${onDelC}('${params.data.uuid}')" style="color:red;">${this.$t('CargoMsg.Cargo_OrderDelete')}</a>
                      </div>`
              } else {
                return `<div>
                        <a onclick="${onDelC}('${params.data.uuid}')" style="color:red;">${this.$t('CargoMsg.Cargo_OrderDelete')}</a>
                      </div>`
              }
            }
          }
        ]
      }
    }
  },
  computed: {
    innerVisible: {
      get() {
        return this.visible
      },
      set(val) {
        if (!val) {
          this.$emit('close', val)
        }
      }
    },
    isEditing() {
      return this.pageType === 0
    }
  },
  async created() {
    await this.init()
  },
  beforeMount() {
    const context = this
    this.documentManage.set('onDelC', function(value) {
      context.onDelC(value)
    })
    this.documentManage.set('onDimension', function(value) {
      context.onDimension(value)
    })
  },
  methods: {
    async init() {
      await cache.load(cacheName.CONFIG)
      this.cWeightIsCeil = Number(cache.config.get('AEcWeightCeil')) // 计费重量是否取整
    },
    onDelC(uuid) {
      if (uuid !== null) {
        this.from.fileList = this.from.fileList.filter(row => row.uuid !== uuid)
        if (!uuid.includes(this.addKey)) {
          this.from.deleteFileList.push(uuid)
        }
      }
    },
    onDimensionFrom() {
      this.dimensionsDialog.dimension = this.from.measurements
      this.dimensionsDialog.singleWeight = 0
      this.dimensionsDialog.uuid = this.from.uuid
      this.dimensionsDialog.visible = true
    },
    onDimension(uuid) {
      if (!this.isEditing) {
        return
      }
      const vo = this.from.dataList.find(p => p.uuid === uuid)
      if (vo) {
        this.dimensionsDialog.dimension = vo.measurements
        this.dimensionsDialog.singleWeight = 0
      }
      this.dimensionsDialog.uuid = uuid
      this.dimensionsDialog.visible = true
    },
    sizeDataHandler(e) {
      if (e.dimension && e.uuid) {
        if (e.uuid === this.from.uuid) {
          this.doSizeDataHandler(this.from, e)
        } else {
          const vo = this.from.dataList.find(p => p.uuid === e.uuid)
          if (vo) {
            this.doSizeDataHandler(vo, e)
          }
          this.calcSum()
        }
      }
    },
    doSizeDataHandler(vo, e) {
      vo.measurements = e.dimension
      const list = e.dimension.split(';')
      let quantity = 0
      for (const d of list) {
        const value = d.split('*')
        if (value.length === 4) {
          quantity += Number(value[3])
        }
      }
      vo.quantity = NumberUtils.ToFixed2(quantity, 0)
    },
    onCancel() {
      this.$emit('close')
    },
    toChooseFile(file) {
      if (file.size > 20 * 1024 * 1024) {
        this.$message.warning(this.$t('Message.N1Exceeds20MBCannotUploaded'))
        return
      }
      const fileName = file.name
      const fileType = fileName.substr(fileName.lastIndexOf('.') + 1)
      const params = { file: file.raw }
      if (this.params) {
        params.jobNo = this.from.jobNo
        params.mbl = this.from.mbl
        params.uuid = this.from.uuid
      }
      const user = this.$store.getters.userInfo
      params.createdBy = user.id
      params.createChineseName = user.chineseName
      params.createEnglishName = user.englishName
      this.from.fileList.push({
        uuid: this.addKey + getUuid(),
        seq: this.autoIncrementNum.getNextNum(),
        fileId: '',
        fileName,
        fileType,
        fileSize: file.size,
        fileCategory: '',
        fileCategoryLabel: '',
        params
      })
    },
    handleEnterHandler() {
      let inputText = this.from.inputText
      if (!inputText) {
        return
      }
      if (!/^.{3}-/.test(inputText)) {
        return
      }
      this.from = PriceUtils.resetFilter(this.from)
      inputText = inputText.replace(/-/g, '')
      inputText = inputText.replace(/\s/g, ' ')
      this.loading = getLoading()
      queryJobForMblFunc({ anyStr: inputText.trim() }).then(res => {
        if (res.data) {
          Object.keys(this.from).forEach((key) => {
            if (res.data[key]) {
              this.from[key] = res.data[key]
            }
          })
          this.from.mblStr = this.from.mbl
          if (this.from.mbl && this.from.mbl.length > 3) {
            this.from.mblStr = this.from.mbl.slice(0, 3) + '-' + this.from.mbl.slice(3)
          }
        }
      }).catch(() => {
        this.loading.close()
      })
      this.loading.close()
    },
    onCellChange(p) {
      this.calcSum()
    },
    chargeWeightChange(e) {
      this.from.chargeWeight = JobUtils.calcChargeWeight(this.from.weight, this.from.volume, true, this.cWeightIsCeil)
    },
    calcSum() {
      if (this.from.dataList) {
        let quantitySum = 0
        let weightSum = 0
        let cubAgeSum = 0
        const measurementList = []
        for (const detail of this.from.dataList) {
          detail.chargeWeight = JobUtils.calcChargeWeight(detail.grossWeight, detail.volume, true, this.cWeightIsCeil)
          quantitySum += NumberUtils.ToFixed2(detail.quantity, 0)
          weightSum += NumberUtils.ToFixed2(detail.grossWeight, 2)
          cubAgeSum += NumberUtils.ToFixed2(detail.volume, 3)
          if (detail.measurements) {
            measurementList.push(detail.measurements)
          }
        }
        this.from.quantity = NumberUtils.ToFixed2(quantitySum, 0)
        this.from.weight = NumberUtils.ToFixed2(weightSum, 2)
        this.from.volume = NumberUtils.ToFixed2(cubAgeSum, 3)
        this.from.measurements = measurementList.join('\n')
        this.chargeWeightChange()
      }
      this.detailList.gridOptions.api.refreshCells({ force: true })
    },
    // 保存
    saveHandler() {
      this.from.pageType = this.pageType
      if (this.from.outboundWeightDate && this.pageType === 0) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrentBusinessAlreadyWeighedOut'))
        return
      }
      if (this.from.deliveryDate && this.pageType === 1) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CurrentBusinessAlreadyDelivered'))
        return
      }
      this.loading = getLoading()
      saveDeliveryOperation(this.from).then(res => {
        if (res.data === 'dataError') {
          if (this.pageType === 0) {
            this.$message.warning(this.$t('CargoMsg.Cargo_CurrentBusinessAlreadyWeighedOut'))
            return
          } else {
            this.$message.warning(this.$t('CargoMsg.Cargo_CurrentBusinessAlreadyDelivered'))
            return
          }
        } else if (res.data) {
          this.$message.success(this.$t('CargoMsg.Cargo_SaveSucceed'))
          this.uploadFunc(res.data)
        }
        this.loading.close()
      }).catch(() => {
        if (this.loading) {
          this.loading.close()
        }
      })
    },
    async uploadFunc(redisKey) {
      if (!redisKey) {
        return
      }
      this.otherProcessing = []
      this.batchUploading = false
      const rows = this.from.fileList.filter(p => !p.fileId)
      if (rows.length === 0) {
        return
      }
      this.loading = getLoading()
      this.uploading = true
      this.fileList.gridApi.refreshCells({ force: true })
      try {
        await Promise.all(
          Array.from(rows, p => {
            const params = p.params
            if (!params.hasOwnProperty('documentType')) {
              params.documentType = p.fileCategory || 'other'
            }
            params.documentName = p.fileCategoryLabel || 'other'
            params.isShared = 'false'
            params.op = 'false'
            params.sales = 'false'
            params.all = 'false'
            params.customer = 'false'
            params.consignee = 'false'
            params.shipper = 'false'
            params.destinationAgent = 'false'
            params.bookingAgent = 'false'
            params.redisKey = redisKey // 这里把文件关联的redisKey传过去
            this.batchUploading = true
            params.branchId = this.$store.getters.currentOfficeId
            params.fileSource = ChargeItemTarget.UPLOAD.code
            return batchUploadFileForJob(params).then(res => {
              p.fileId = res.data
              p.fileCategory = params.documentType
              p.fileCategoryLabel = params.documentName
              this.$emit('uploadSuccess')
            })
          })
        )
      } catch {
        if (this.loading) {
          this.loading.close()
        }
        const uploadSuccessCount = rows.filter(p => p.fileId).length
        const uploadFailCount = rows.filter(p => !p.fileId).length
        await this.$confirm(
          this.$t('queryJob.Upload0UploadFailed0', [uploadSuccessCount, uploadFailCount]),
          this.$t('common.tips.prompt'),
          {
            showClose: false,
            confirmButtonText: this.$t('common.btn.ok'),
            showCancelButton: false,
            type: 'warning'
          }
        )
      } finally {
        this.$emit('uploadDoneOtherProcessing', { row: this.otherProcessing })
        if (this.loading) {
          this.loading.close()
        }
        this.uploading = false
        this.fileList.gridApi.refreshCells({ force: true })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .input-border.el-input--mini .el-input__inner {
  height: 60px;
  font-size: 40px;
  line-height: 28px;
}
.centered-cell {
  text-align: center; /* 文字居中对齐 */
  width: 30%;
}
</style>
